import io from 'socket.io-client'

const mixin = {
  data() {
    return {
      badgeCount: 0
    }
  },
  methods: {
    connectSocket: function() {
      this.socket = io(this.socketURI, {
        reconnection: true,
        transports: ['websocket', 'polling'],
        query: `folios=${this.order.folio}&access_token=${this.token}`
      })
    },
    configureSocket: function() {
      // Update folio
      this.socket.on('folio_update', this.onUpdateFolio)

      // Update driver location
      this.socket.on('driver_update', this.onUpdateDriverLocation)

      // Connection successfully
      this.socket.on('connect', function() {
        if (process.env.NODE_ENV === 'development') {
          console.log('connect')
        }
      })

      // Reconnection succesfully
      this.socket.on('reconnect', function() {
        if (process.env.NODE_ENV === 'development') {
          console.log('reconnect')
        }
      })

      // Reconnecting
      this.socket.on('reconnecting', function() {
        if (process.env.NODE_ENV === 'development') {
          console.log('reconnecting')
        }
      })

      // Error to connect
      this.socket.on('error', this.onSocketError)

      // Disconnect
      this.socket.on('disconnect', function(data) {
        if (process.env.NODE_ENV === 'development') {
          console.log('disconnect')
          console.log(data)
        }
      })
    },
    onNewETANotificationFromSockets: function(data) {
      if (data.ETA) {
        data.ETA.createdAt = new Date()
        this.messagesAlerts.push(data.ETA)
        this.badgeCount++
        this.$message({
          dangerouslyUseHTMLString: true,
          message: data.ETA.message,
          duration: 3000
        })
        this.$store.commit('NOTIFICATIONS_DATA', this.messagesAlerts)
        this.$store.commit('COUNT_NOTIFICATIONS', this.badgeCount)
      }
    },
    showNotifications: function(value) {
      this.badgeCount = 0
      this.$store.commit('COUNT_NOTIFICATIONS', 0)
      this.flags.notifications = value
    }
  }
}

export default mixin
